"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var next_components_1 = require("@dotdev/next-components");
var GiftCardBalance = /** @class */ (function (_super) {
    __extends(GiftCardBalance, _super);
    function GiftCardBalance(props) {
        var _this = _super.call(this, props) || this;
        _this.giftCardInput = React.createRef();
        _this.handleGiftCardChange = function (event) {
            var properties = _this.state.properties;
            properties[event.target.name] = event.target.value.replace(/(?:\r\n|\r|\n)/g, "<br />");
            _this.setState({
                properties: properties,
                update: event.target.name + "-" + event.target.value
            });
        };
        _this.handleGiftCardLookup = function () { return __awaiter(_this, void 0, void 0, function () {
            var endpoint, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = "/apps/dotapparel/api-checkGiftcardBalance";
                        if (!(this.state.properties && this.state.properties.number && this.state.properties.pin)) return [3 /*break*/, 2];
                        this.setState({
                            fetching: true,
                            errors: null
                        });
                        return [4 /*yield*/, fetch(endpoint, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify(this.state.properties)
                            })
                                .then(function (response) { return response.json(); })
                                .then(function (data) {
                                _this.setState({
                                    response: data.errors ? data : data.data,
                                    fetching: false
                                });
                            })];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.setState({
                            errors: "Please fill out all fields"
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            errors: null,
            response: {},
            properties: {},
            update: null
        };
        _this.handleGiftCardChange = _this.handleGiftCardChange.bind(_this);
        return _this;
    }
    GiftCardBalance.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        !prevProps.active && this.props.active
            ? setTimeout(function () {
                _this.giftCardInput.current.focus();
            }, 500)
            : null;
    };
    GiftCardBalance.prototype.render = function () {
        var _this = this;
        var shop = this.props.data.shop;
        return (React.createElement("div", { className: this.props.className },
            React.createElement(Snippets.Input, { reference: this.giftCardInput, type: "text", style: "large", className: "w-full mb-1-7", placeholder: "Gift Voucher Number", name: "number", onChange: function (event) { return _this.handleGiftCardChange(event); } }),
            React.createElement(Snippets.Input, { type: "text", style: "large", className: "w-full", placeholder: "Gift Voucher PIN", name: "pin", onChange: function (event) { return _this.handleGiftCardChange(event); } }),
            this.state.response &&
                (this.state.response.originalAmount || this.state.response.availableAmount || this.state.response.expiryDate) &&
                !this.state.response.errors ? (React.createElement("div", { className: "px-2-4 py-1-8 mt-1-7 text-left" },
                this.state.response.originalAmount ? (React.createElement("div", { className: "flex flex-col md:flex-row items-center justify-start text-sm leading-tight" },
                    React.createElement("p", { className: "w-full md:w-1/4" }, "Value:"),
                    React.createElement("p", { className: "w-full md:w-3/4" }, next_components_1.ShopifyNext.Utils.formatMoney(this.state.response.originalAmount * 100, shop.money_format)))) : null,
                this.state.response.availableAmount ? (React.createElement("div", { className: "flex flex-col md:flex-row items-center justify-start text-sm leading-tight mt-0-8 md:mt-0" },
                    React.createElement("p", { className: "w-full md:w-1/4" }, "Balance:"),
                    React.createElement("p", { className: "w-full md:w-3/4" }, next_components_1.ShopifyNext.Utils.formatMoney(this.state.response.availableAmount * 100, shop.money_format)))) : null,
                this.state.response.expiryDate ? (React.createElement("div", { className: "flex flex-col md:flex-row items-center justify-start text-sm leading-tight mt-0-8 md:mt-0" },
                    React.createElement("p", { className: "w-full md:w-1/4" }, "Expires:"),
                    React.createElement("p", { className: "w-full md:w-3/4" }, next_components_1.ShopifyNext.Utils.formatDate(this.state.response.expiryDate, "DD/MM/YYYY")))) : null)) : this.state.response && this.state.response.errors && this.state.response.errors.length ? (React.createElement(Snippets.FormErrors, { errors: this.state.response.errors[0].includes("Invalid")
                    ? "We couldn't find a valid gift voucher with those details"
                    : this.state.response.errors[0], icon: "cancel", className: "mt-1-8" })) : this.state.errors ? (React.createElement(Snippets.FormErrors, { errors: this.state.errors, className: "mt-1-8" })) : null,
            React.createElement(Snippets.Button, { style: "tertiary", className: "w-full mt-1-7 rounded", onClick: this.handleGiftCardLookup, disabled: this.state.fetching || !(this.state.properties && this.state.properties.number && this.state.properties.pin) }, this.state.fetching ? "Checking Balance" : "Check Balance")));
    };
    return GiftCardBalance;
}(React.PureComponent));
exports.GiftCardBalance = GiftCardBalance;
